// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_string = require("rescript/lib/js/js_string.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Domain$ReactHooksTemplate = require("./domain.res.js");
var ToggleInput$ReactHooksTemplate = require("../common/ToggleInput.res.js");
var SelectBoxNew$ReactHooksTemplate = require("../common/SelectBoxNew.res.js");
var TextInputNew$ReactHooksTemplate = require("../common/TextInputNew.res.js");

function DomainCreate(props) {
  var handleReturn = props.handleReturn;
  var handleAlert = props.handleAlert;
  var domain = props.domain;
  var initialState = domain !== undefined ? ({
        domain: Caml_option.valFromOption(domain),
        action: "Update",
        notification: undefined,
        validationError: undefined,
        confirmationAction: undefined
      }) : ({
        domain: Domain$ReactHooksTemplate.empty(),
        action: "Create",
        notification: undefined,
        validationError: undefined,
        confirmationAction: undefined
      });
  var match = React.useState(function (param) {
        return initialState;
      });
  var setState = match[1];
  var state = match[0];
  var validateLabelLength = function (value) {
    return value.split(".").every(function (label) {
                return label.length < 63;
              });
  };
  var validateDomainName = function (value) {
    if (value.length === 0) {
      return "Domain name can't be empty";
    }
    var match = Domain$ReactHooksTemplate.domainType(state.domain);
    if (match === "Custom") {
      if (value.length > 253) {
        return "Domain length is too long";
      } else {
        return ;
      }
    } else if (!validateLabelLength(value)) {
      return "Label length must not exceed 63 characters";
    } else {
      return ;
    }
  };
  var handleDomainName = function ($$event) {
    var value = $$event.target.value;
    var validationError = validateDomainName(value);
    var match = Domain$ReactHooksTemplate.domainType(state.domain);
    var newDomainName;
    newDomainName = match === "Custom" ? value : value + ".geckolyst.com";
    Curry._1(setState, (function (state) {
            return {
                    domain: Domain$ReactHooksTemplate.setDomainName(state.domain, newDomainName),
                    action: state.action,
                    notification: state.notification,
                    validationError: validationError,
                    confirmationAction: state.confirmationAction
                  };
          }));
  };
  console.log(state);
  var confirmationPopUp = function (message, handleClose, handleSave) {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: message
                                  }),
                              className: "p-8 text-lg font-bold flex justify-center items-center"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("p", {
                                                  children: "Cancel"
                                                }),
                                            className: "text-darkcharcoal hover:text-pigmentblue"
                                          }),
                                      className: "bg-ghostwhite border border-gray-400 cursor-pointer\n                  flex justify-center items-center rounded p-2 text-sm hover:border-pigmentblue w-3/12",
                                      onClick: (function (param) {
                                          Curry._1(handleClose, undefined);
                                        })
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("p", {
                                                  children: "Continue"
                                                }),
                                            className: "text-white"
                                          }),
                                      className: "bg-pigmentblue border border-gray-400 cursor-pointer flex justify-center items-center rounded p-2 text-sm hover:bg-cetaceanblue w-3/12",
                                      onClick: Curry.__1(handleSave)
                                    })
                              ],
                              className: "p-8 flex gap-3 absolute bottom-0 w-full justify-end"
                            })
                      ],
                      className: "bg-white z-10 shadow relative border border-gray-300 rounded-lg h-200-px w-5/12"
                    }),
                className: "z-10 disabled-wrapper absolute inset-0 flex justify-center items-center",
                style: {
                  height: "calc(100vh + 5rem)"
                }
              });
  };
  var handleSubmit = function ($$event) {
    $$event.preventDefault();
    var validationError = validateDomainName(Domain$ReactHooksTemplate.name(state.domain));
    Curry._1(setState, (function (state) {
            return {
                    domain: state.domain,
                    action: state.action,
                    notification: state.notification,
                    validationError: validationError,
                    confirmationAction: state.confirmationAction
                  };
          }));
    if (validationError !== undefined) {
      return ;
    }
    var url = "/api/v1/domains/check_domain_name?name=" + Domain$ReactHooksTemplate.name(state.domain);
    var encodedDomain = Domain$ReactHooksTemplate.encode(state.domain);
    var params = {};
    params["domain"] = encodedDomain;
    var match = state.action;
    if (match === "Create") {
      Js_promise.then_((function (available) {
              if (available) {
                return Js_promise.then_((function (response) {
                              var status = Json_decode.field("status", (function (param) {
                                      return Json_decode.withDefault("failure", Json_decode.string, param);
                                    }), response);
                              if (status === "success") {
                                Curry._1(handleAlert, {
                                      TAG: "Success",
                                      _0: "Domain created successfully"
                                    });
                                Curry._1(handleReturn, undefined);
                              } else {
                                Curry._1(handleAlert, {
                                      TAG: "Failure",
                                      _0: "Failed to create domain"
                                    });
                              }
                              return Promise.resolve();
                            }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/domains", params));
              } else {
                Curry._1(setState, (function (state) {
                        return {
                                domain: state.domain,
                                action: state.action,
                                notification: state.notification,
                                validationError: "Domain name is already taken",
                                confirmationAction: state.confirmationAction
                              };
                      }));
                return Promise.resolve();
              }
            }), Http$ReactHooksTemplate.fetchGetJSONDecode(url, (function (param) {
                  return Json_decode.field("available", Json_decode.bool, param);
                })));
      return ;
    }
    Js_promise.then_((function (response) {
            var status = Json_decode.field("status", (function (param) {
                    return Json_decode.withDefault("failure", Json_decode.string, param);
                  }), response);
            if (status === "success") {
              Curry._1(handleAlert, {
                    TAG: "Success",
                    _0: "Domain updated successfully"
                  });
              Curry._1(handleReturn, undefined);
            } else {
              Curry._1(handleAlert, {
                    TAG: "Failure",
                    _0: "Failed to update domain"
                  });
            }
            return Promise.resolve();
          }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/domains/" + String(Belt_Option.getExn(Domain$ReactHooksTemplate.id(state.domain))) + "/update", params));
  };
  var match$1 = state.confirmationAction;
  var tmp;
  tmp = match$1 !== undefined ? (
      match$1 === "ShowSurveyFeedbackConfirmation" ? confirmationPopUp("Assigning this domain will override the existing survey feedback domain. Do you want to continue?", (function (param) {
                Curry._1(setState, (function (state) {
                        return {
                                domain: state.domain,
                                action: state.action,
                                notification: state.notification,
                                validationError: state.validationError,
                                confirmationAction: undefined
                              };
                      }));
              }), (function (param) {
                Curry._1(setState, (function (state) {
                        return {
                                domain: Domain$ReactHooksTemplate.toggleSurveyFeedbackDomain(state.domain),
                                action: state.action,
                                notification: state.notification,
                                validationError: state.validationError,
                                confirmationAction: undefined
                              };
                      }));
              })) : confirmationPopUp("Assigning this domain will override the existing internal communication domain. Do you want to continue?", (function (param) {
                Curry._1(setState, (function (state) {
                        return {
                                domain: state.domain,
                                action: state.action,
                                notification: state.notification,
                                validationError: state.validationError,
                                confirmationAction: undefined
                              };
                      }));
              }), (function (param) {
                Curry._1(setState, (function (state) {
                        return {
                                domain: Domain$ReactHooksTemplate.toggleInternalCommunicationdomain(state.domain),
                                action: state.action,
                                notification: state.notification,
                                validationError: state.validationError,
                                confirmationAction: undefined
                              };
                      }));
              }))
    ) : null;
  var match$2 = state.action;
  var tmp$1;
  tmp$1 = match$2 === "Create" ? "Add New Domain" : "Update Domain";
  var match$3 = Domain$ReactHooksTemplate.domainType(state.domain);
  var tmp$2;
  if (match$3 === "Custom") {
    tmp$2 = Domain$ReactHooksTemplate.name(state.domain);
  } else {
    var fullname = Domain$ReactHooksTemplate.name(state.domain);
    tmp$2 = Js_string.replace(".geckolyst.com", "", fullname);
  }
  var error = state.validationError;
  var match$4 = Domain$ReactHooksTemplate.domainType(state.domain);
  var tmp$3;
  tmp$3 = match$4 === "Custom" ? null : JsxRuntime.jsx("span", {
          children: ".geckolyst.com",
          className: "text-gray-500 text-sm font-medium"
        });
  var match$5 = state.action;
  var tmp$4;
  tmp$4 = match$5 === "Create" ? "Create Domain" : "Update Domain";
  return JsxRuntime.jsxs("div", {
              children: [
                tmp,
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("span", {
                                                  children: "➕",
                                                  className: "text-xl"
                                                }),
                                            className: "flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-blue-100 to-indigo-100 shadow-sm"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("h1", {
                                                    children: tmp$1,
                                                    className: "text-2xl font-bold text-gray-900"
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: "Configure your domain settings and permissions",
                                                    className: "text-sm text-gray-600 mt-1"
                                                  })
                                            ]
                                          })
                                    ],
                                    className: "flex items-center space-x-3"
                                  }),
                              className: "bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-6 border-b border-gray-200"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("form", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(SelectBoxNew$ReactHooksTemplate.make, {
                                                  label: "Domain Type",
                                                  value: Domain$ReactHooksTemplate.domainTypeToString(state.domain),
                                                  handleChange: (function ($$event) {
                                                      var value = $$event.target.value;
                                                      var newDomainType = value === "custom" ? "Custom" : "Subdomain";
                                                      var newVerificationStatus = newDomainType === "Custom" ? "Pending" : "NotApplicable";
                                                      var newActiveType = newVerificationStatus !== "Pending";
                                                      Curry._1(setState, (function (state) {
                                                              return {
                                                                      domain: Domain$ReactHooksTemplate.setActive(Domain$ReactHooksTemplate.setVerificationStatus(Domain$ReactHooksTemplate.setDomainType(state.domain, newDomainType), newVerificationStatus), newActiveType),
                                                                      action: state.action,
                                                                      notification: state.notification,
                                                                      validationError: state.validationError,
                                                                      confirmationAction: state.confirmationAction
                                                                    };
                                                            }));
                                                    }),
                                                  labelCSS: "text-sm font-medium text-gray-700",
                                                  options: {
                                                    hd: "custom",
                                                    tl: {
                                                      hd: "subdomain",
                                                      tl: /* [] */0
                                                    }
                                                  }
                                                }),
                                            className: "bg-gray-50 rounded-lg p-4"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("label", {
                                                    children: "Domain Name",
                                                    className: "block text-sm font-medium text-gray-700 mb-2"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("div", {
                                                            children: JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                                                                  label: "",
                                                                  value: tmp$2,
                                                                  handleChange: handleDomainName,
                                                                  errorCSS: "text-sm text-red-600 mt-1",
                                                                  errorText: error !== undefined ? error : "",
                                                                  error: state.validationError !== undefined,
                                                                  labelCSS: "",
                                                                  textInputClassName: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                                                                  containerClassName: "w-full",
                                                                  inputBoxContainerCss: "w-full"
                                                                }),
                                                            className: "flex-1"
                                                          }),
                                                      tmp$3
                                                    ],
                                                    className: "flex items-center space-x-2"
                                                  })
                                            ],
                                            className: "bg-gray-50 rounded-lg p-4"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("h3", {
                                                    children: "Domain Settings",
                                                    className: "text-lg font-medium text-gray-900"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    JsxRuntime.jsx("h4", {
                                                                          children: "Active",
                                                                          className: "text-sm font-medium text-gray-900"
                                                                        }),
                                                                    JsxRuntime.jsx("p", {
                                                                          children: "Enable or disable this domain",
                                                                          className: "text-xs text-gray-500"
                                                                        })
                                                                  ]
                                                                }),
                                                            JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                                                  checked: Domain$ReactHooksTemplate.active(state.domain),
                                                                  handleChange: (function (param) {
                                                                      if (Domain$ReactHooksTemplate.active(state.domain) === true) {
                                                                        Curry._1(handleAlert, {
                                                                              TAG: "Warning",
                                                                              _0: "Any survey feedback URL sent using the domain will not work after deactivation"
                                                                            });
                                                                      }
                                                                      Curry._1(setState, (function (state) {
                                                                              return {
                                                                                      domain: Domain$ReactHooksTemplate.toggleActive(state.domain),
                                                                                      action: state.action,
                                                                                      notification: state.notification,
                                                                                      validationError: state.validationError,
                                                                                      confirmationAction: state.confirmationAction
                                                                                    };
                                                                            }));
                                                                    }),
                                                                  labelClassName: "flex items-center"
                                                                })
                                                          ],
                                                          className: "flex items-center justify-between"
                                                        }),
                                                    className: "bg-white border border-gray-200 rounded-lg p-4 " + (
                                                      Domain$ReactHooksTemplate.verificationStatus(state.domain) === "Pending" ? "opacity-50 pointer-events-none" : ""
                                                    )
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    JsxRuntime.jsx("h4", {
                                                                          children: "Default Domain",
                                                                          className: "text-sm font-medium text-gray-900"
                                                                        }),
                                                                    JsxRuntime.jsx("p", {
                                                                          children: "Set as the primary domain for your organization",
                                                                          className: "text-xs text-gray-500"
                                                                        })
                                                                  ]
                                                                }),
                                                            JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                                                  checked: Domain$ReactHooksTemplate.defaultDomain(state.domain),
                                                                  handleChange: (function (param) {
                                                                      Curry._1(setState, (function (state) {
                                                                              return {
                                                                                      domain: Domain$ReactHooksTemplate.toggleDefaultDomain(state.domain),
                                                                                      action: state.action,
                                                                                      notification: state.notification,
                                                                                      validationError: state.validationError,
                                                                                      confirmationAction: state.confirmationAction
                                                                                    };
                                                                            }));
                                                                    }),
                                                                  labelClassName: "flex items-center"
                                                                })
                                                          ],
                                                          className: "flex items-center justify-between"
                                                        }),
                                                    className: "bg-white border border-gray-200 rounded-lg p-4 " + (
                                                      Domain$ReactHooksTemplate.verificationStatus(state.domain) === "Pending" ? "opacity-50 pointer-events-none" : ""
                                                    )
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    JsxRuntime.jsx("h4", {
                                                                          children: "Survey Feedback Domain",
                                                                          className: "text-sm font-medium text-gray-900"
                                                                        }),
                                                                    JsxRuntime.jsx("p", {
                                                                          children: "Use this domain for survey feedback URLs",
                                                                          className: "text-xs text-gray-500"
                                                                        })
                                                                  ]
                                                                }),
                                                            JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                                                  checked: Domain$ReactHooksTemplate.surveyFeedbackDomain(state.domain),
                                                                  handleChange: (function (param) {
                                                                      if (Domain$ReactHooksTemplate.surveyFeedbackDomain(state.domain)) {
                                                                        return Curry._1(setState, (function (state) {
                                                                                      return {
                                                                                              domain: Domain$ReactHooksTemplate.toggleSurveyFeedbackDomain(state.domain),
                                                                                              action: state.action,
                                                                                              notification: state.notification,
                                                                                              validationError: state.validationError,
                                                                                              confirmationAction: state.confirmationAction
                                                                                            };
                                                                                    }));
                                                                      } else {
                                                                        return Curry._1(setState, (function (state) {
                                                                                      return {
                                                                                              domain: state.domain,
                                                                                              action: state.action,
                                                                                              notification: state.notification,
                                                                                              validationError: state.validationError,
                                                                                              confirmationAction: "ShowSurveyFeedbackConfirmation"
                                                                                            };
                                                                                    }));
                                                                      }
                                                                    }),
                                                                  labelClassName: "flex items-center"
                                                                })
                                                          ],
                                                          className: "flex items-center justify-between"
                                                        }),
                                                    className: "bg-white border border-gray-200 rounded-lg p-4 " + (
                                                      Domain$ReactHooksTemplate.verificationStatus(state.domain) === "Pending" ? "opacity-50 pointer-events-none" : ""
                                                    )
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    JsxRuntime.jsx("h4", {
                                                                          children: "Internal Communication Domain",
                                                                          className: "text-sm font-medium text-gray-900"
                                                                        }),
                                                                    JsxRuntime.jsx("p", {
                                                                          children: "Use this domain for internal communications",
                                                                          className: "text-xs text-gray-500"
                                                                        })
                                                                  ]
                                                                }),
                                                            JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                                                  checked: Domain$ReactHooksTemplate.internalCommunicationDomain(state.domain),
                                                                  handleChange: (function (param) {
                                                                      if (Domain$ReactHooksTemplate.internalCommunicationDomain(state.domain)) {
                                                                        return Curry._1(setState, (function (state) {
                                                                                      return {
                                                                                              domain: Domain$ReactHooksTemplate.toggleInternalCommunicationdomain(state.domain),
                                                                                              action: state.action,
                                                                                              notification: state.notification,
                                                                                              validationError: state.validationError,
                                                                                              confirmationAction: state.confirmationAction
                                                                                            };
                                                                                    }));
                                                                      } else {
                                                                        return Curry._1(setState, (function (state) {
                                                                                      return {
                                                                                              domain: state.domain,
                                                                                              action: state.action,
                                                                                              notification: state.notification,
                                                                                              validationError: state.validationError,
                                                                                              confirmationAction: "ShowInternalCommunicationConfirmation"
                                                                                            };
                                                                                    }));
                                                                      }
                                                                    }),
                                                                  labelClassName: "flex items-center"
                                                                })
                                                          ],
                                                          className: "flex items-center justify-between"
                                                        }),
                                                    className: "bg-white border border-gray-200 rounded-lg p-4 " + (
                                                      Domain$ReactHooksTemplate.verificationStatus(state.domain) === "Pending" ? "opacity-50 pointer-events-none" : ""
                                                    )
                                                  })
                                            ],
                                            className: "space-y-4"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("button", {
                                                    children: "Cancel",
                                                    className: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                                    type: "button",
                                                    onClick: (function (param) {
                                                        Curry._1(handleReturn, undefined);
                                                      })
                                                  }),
                                              JsxRuntime.jsx("button", {
                                                    children: tmp$4,
                                                    className: "px-6 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                                    type: "submit"
                                                  })
                                            ],
                                            className: "flex justify-end space-x-3 pt-6 border-t border-gray-200"
                                          })
                                    ],
                                    className: "space-y-6",
                                    onSubmit: handleSubmit
                                  }),
                              className: "p-6"
                            })
                      ],
                      className: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden"
                    })
              ]
            });
}

var make = DomainCreate;

exports.make = make;
/* react Not a pure module */
